<template>
  <v-card :to="to" class="d-flex keep-size align-center" elevation="0">
    <div class="bg-light-green circle d-flex justify-center align-center mr-2 background-circle" >
      <slot name="icon"/>
    </div>
    <div class="ellipsis justify-content-center align-self-center ">
      <b class="pointer title-text light-green--text">
        <slot name="title"/>
      </b>
      <span class="subtitle-text ">
        <slot name="subtitle"/>
      </span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "FAQMobileDataTableRow",

  props: {
    to: Object
  },

};
</script>

<style scoped>
.title-text {
  font-size: 15px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.subtitle-text {
  color: #4c4c4c;
  font-size: 10px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.keep-size {
  height: 50px;
  width: 100%;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.background-circle {
  width: 35px;
  height: 35px;
  min-width: 35px
}
</style>